import {
  Category,
  ContentGroup,
  ContentFilters,
  Content,
  ContentSummary,
  ContentDetail,
  ContentType,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  ContentRelatedRequest,
  CustomContentFilter,
  EntityData,
  IContentService,
  PostContentDetail,
  RemoteContentDetail,
  RemoteContentReference,
  RemoteSchema,
  SearchResult,
} from "./IContentService";
import Sdk from "api.digitalpages.module.sdk.api";
import { ContentTypeV as ContentMimeType } from "../../components/WPageBookDetail";
import { hasCategory } from "../../utilities/Categories";

export class ContentServiceApi implements IContentService {
  async GetProgressRead(contentGroupId: string) {
      const url = `cms/v1.1/managed/content/group/uid/${contentGroupId}/interactions`;
      return await Sdk.Api.dynamic
        .bridge(url, null, "GET")
        .then(res => res)
        .catch((err) => {
          console.log(err);
        });
  }
  async donwloadNow(): Promise<any[]> {
    const references = [
      {
        uid: "1",
        format: ContentMimeType.EPUB,
        downloadProgress: 0,
      },
      {
        uid: "2",
        format: ContentMimeType.PDF,
        downloadProgress: 0,
      },
      {
        uid: "3",
        format: ContentMimeType.AUDIOBOOK,
        downloadProgress: 0,
      },
    ];
    const epubReference = references.find((ref) => ref.format === ContentMimeType.EPUB);
  
    if (epubReference) {
      epubReference.downloadProgress = 0;

      // const interval = setInterval(() => {
    //     epubReference.downloadProgress += 10;

    //     if (epubReference.downloadProgress >= 100) {
    //       clearInterval(interval);
    //     }
    // const dispatch = useDispatch();

    //     dispatch(updateDownloadProgress(references));
      // }, 26000);
    }
    const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

    await delay(4000);
    return references;
  }

  async Schemas(): Promise<RemoteSchema[]> {
    var schemas = await this.LoadSchemas();

    for (const schema of schemas) {
      const entities = await this.LoadEntities(schema);
      schema.categories = entities.map((p) => this.ToCategory(p));
    }

    return schemas;
  }

  async MostWantedContents(): Promise<RemoteContentDetail[]> {
    var query = "order_consumption=desc&page_size=6";

    if (Sdk.Api.authorization.credential != null) {
      query += "&only_new_contents=true";
    }

    var contents = await this.Contents({ customQuery: query });
    return contents.result;

    // return {
    //   books: contents.result,
    //   title: "Os mais buscados",
    //   uid: "maisbuscados",
    // };
  }

  async RelatedContents(info: ContentRelatedRequest): Promise<RemoteContentDetail[]> {
    var query = `exclude_content=${info.content.uid}&order_consumption=desc&page_size=6`;

    if (Sdk.Api.authorization.credential != null) {
      query += "&only_new_contents=true";
    }

    var entityTypeCategory = info.content.entities?.filter((e)=> hasCategory(e.entityUid, info.categoriesAvailableForUser));
    entityTypeCategory?.forEach((e) => (query += `&all_entity=${e.entityUid}`));

    var contents = await this.Contents({ customQuery: query });

    return contents.result;
    // return {
    //   books: contents.result,
    //   title: "Quem leu também gostou",
    //   uid: "tbmgostou",
    // };
  }

  async SuggestedContents(): Promise<RemoteContentDetail[]> {
    var query = "order_consumption=desc&only_new_contents=true&page_size=6";

    var contents = await this.Contents({ customQuery: query });
    return contents.result;
    // return {
    //   books: contents.result,
    //   title: "Você pode gostar",
    //   uid: "podegostar",
    // };
  }

  async HistoryContents(): Promise<RemoteContentDetail[]> {
    if(!Sdk.Api.authorization.authenticated) return [];
    
    var url = `cms/v1.1/managed/content/history?page_size=6&order=desc&include_properties=true&include_entities=true`;
    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");
    var uids: string[] = [];
    var contents = response.result
      .filter((value: any) => {
        var notFound = uids.indexOf(value.uid) == -1;
        if (notFound) uids.push(value.uid);

        return notFound;
      })
    const promises: Promise<any>[] = [];

    contents.forEach((contentGroup: any) => {
      promises.push(this.GetProgressRead(contentGroup.uid))
    })

    var result = contents.map((data: any) => this.ToContent(data));

    await Promise.all(promises).then((interactions) => {
      result = result.map((item: any, i: number) => ({ 
        ...item,
        interactions: interactions[i]
      }))
    });

    return result;
  }

  async ReviewContents(): Promise<RemoteContentDetail[]> {
    var url = `cms/v1.1/managed/content/history?page_size=6&order=desc&include_properties=true&include_entities=true&page=2`;
    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");
    var uids: string[] = [];
    var result = response.result
      .filter((value: any) => {
        var notFound = uids.indexOf(value.uid) == -1;
        if (notFound) uids.push(value.uid);

        return notFound;
      })
      .map((data: any) => this.ToContent(data));

    return result;
  }

  async ContentDetailResumed(contentUid: string): Promise<RemoteContentDetail>  {
    var url = `cms/v1.1/managed/content/group/uid/${contentUid}`;
    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");
    var result: RemoteContentDetail = this.ToContentComplete(response);
    return result;
  }

  async ContentDetail(contentUid: string): Promise<RemoteContentDetail> 
  {
    var url = `cms/v1.1/managed/content/group/uid/${contentUid}`;
    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");

    var result: RemoteContentDetail & { fullReview?: any } = this.ToContentComplete(response);

    const userScore= `cms/v1.1/evaluation/managedContent/uid/${contentUid}/score/user`
    await Sdk.Api.dynamic.bridge(userScore, null, 'GET')
    .then(userScoreResponse => {
      if(userScoreResponse.length > 0) 
      {
        const [review] = userScoreResponse
        result.fullReview = review.uid;
        result.userEvaluation = userScoreResponse.pop().note
      }
      else {
        result.userEvaluation = undefined;
        result.fullReview = undefined;
      }
    });

    try{
      const contentScore= `cms/v1.1/evaluation/managedContent/uid/${contentUid}/score`
      const contentScoreResponse = await Sdk.Api.dynamic.bridge(contentScore, null, 'GET');
      result.evaluation = contentScoreResponse.result;
    }catch(e)
    {
      result.evaluation = "0";
    }

    return result;
  }

  async Contents(
    filter?: CustomContentFilter | undefined
  ): Promise<SearchResult> {
    var url = `cms/v1.1/managed/content/available?include_properties=true&include_entities=true`;

    if (filter?.category) url += `&any_entity=${filter.category.uid}`;
    if (filter?.query) url += `&search=${filter.query}`;
    if (filter?.customQuery) url += `&${filter.customQuery}`;

    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");
    var data = response.result.map((data: any) => this.ToContent(data));

    var result: SearchResult = {
      page: response.current_page,
      pageSize: response.page_size,
      nextQuery: response.next_page_query,
      totalResult : response.total_results,
      result: data,
    };

    return result;
  }

  ToContent(serverData: any, ignoreImageOptions?: boolean): RemoteContentDetail 
  {
    var thumbLink = `cms/v1.1/managed/content/group/uid/${serverData.uid}/default/thumb`;
    
    if (!ignoreImageOptions) thumbLink = `${thumbLink}?image_options=width:200`;

    var thumbUrl = Sdk.Api.dynamic.bridgeUrl(thumbLink,null);
    
    var content: RemoteContentDetail = {
      uid: serverData.uid,
      title: serverData.name,
      author: serverData.properties && serverData.properties.find((p: any) => p.name === "Autor")?.value,
      description: !serverData.properties ? "" :  serverData.properties.find(
        (p: any) => p.name === "Descrição"
      )?.value,
      readingTime: !serverData.properties ? "" : serverData.properties.find((p: any) => p.name === "Tempo de leitura") ?.value ?? "Tempo não estimado",
      edition: !serverData.properties ? "" : serverData.properties.find((p: any) => p.name === "Número da edição")?.value ?? serverData.properties.find((p: any) => p.name === "Edição")?.value,
      image: serverData.image,
      entities: serverData.entities?.map((p: any) => {
        var result: EntityData = {
          uid: p.uid,
          entityUid: p.entity_uid,
        };

        return result;
      }),
    };

    if (!content.image) content.image = thumbUrl;

    return content;
  }

  async ContentSummary(serverData: RemoteContentDetail): Promise<ContentSummary[]> {
    let pdfSummary: ContentSummary[] = [];
    let epubSummary: ContentSummary[] = [];
  
    if (serverData.references && Array.isArray(serverData.references)) {
      for (const reference of serverData.references) {
        if (reference.mimeType === "application/epub+zip") {
          epubSummary = await this.getEpubSummary(reference.uid);
          pdfSummary = pdfSummary.map((item) => ({ ...item, type: "pdf" }));  
        } else if (reference.mimeType === "digitalpages/richpack") {
          pdfSummary = await this.getPdfSummary(reference.uid);
          // epubSummary = pdfSummary.map((item) => ({...item, type: "pub"}));
        }
      }
    }
    
    const result: ContentSummary[] = [...pdfSummary, ...epubSummary];

    return result;
  }

  async getPdfSummary(uid: string): Promise<ContentSummary[]> {
    const response = await this.GetPdfSummary(uid);
    const pdfSummary: ContentSummary[] = this.ToPdfSummary(response, "pdf");
    return this.uniqueContentSummary(pdfSummary);
  }

  async getEpubSummary(uid: string): Promise<ContentSummary[]> {
    const response = await this.GetEpubSummary(uid);
    const epubSummary: ContentSummary[] = this.ToEpubSummary(response, "pub");
    const unique = this.uniqueContentSummary(epubSummary);
    return unique;
  }
  
  summaryFormater(contentSummary: any[]) {
    return contentSummary.filter(item => item && item.title.length);
  };

  uniqueContentSummary(contentSummary: any[]): any[] {
    return contentSummary.reduce((prev, current) => {
      if (
        !prev.some(
          (x: { title: any; type: any }) =>
            x.title === current.title && x.type === current.type
        )
      ) {
        return [...prev, current];
      }
      return prev;
    }, []);
  }

  async GetEpubSummary(uid: string): Promise<HTMLCollectionOf<Element>> {
    var result: HTMLCollectionOf<Element>;

    try {
      var url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
      var response: any = Sdk.Api.dynamic.bridgeUrl(url, null);
      
      let contentToc = await fetch(response);
      var contentTocUrl = contentToc.url.replace("content.opf?", "toc.ncx?");
      
      var manifest = await fetch(contentTocUrl).then((p) => p.text());
      
      const parser = new DOMParser();
      const xml = parser.parseFromString(manifest, "text/xml");
      result = xml.getElementsByTagName("navPoint");
      return result;
    }
    catch(err) {
      console.log(err);
    }

    throw Error('')
  }

  async GetPdfSummary(uid: string): Promise<any> {
    var url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");

    if (response && response.sections) {
      return response;
    }
    if (response && response.json) {
      return await response.json();
    }

    return null;
  }

  async GetContentReferenceTarget(uid: string): Promise<any> {
    var url = `cms/v1.1/managed/content/reference/uid/${uid}/default/target`;
    var response: any = await Sdk.Api.dynamic.bridge(url, null, "GET");

    return response;
  }

  ToPdfSummary(serverData: any, summary_type: string): any {
    var result: any[] = [];

    if(serverData && serverData.sections) {
      var pageSets = serverData.sections[0].pageSets;

      for (const pageSet of pageSets) {
        const navLink = { 
          page: pageSet.orderIndex,
          section: pageSet.sectionIndex
        };

        result.push({
          type: summary_type,
          uid: pageSet.portrait.linkPage,
          title: pageSet.portrait.bookmark,
          navLink: JSON.stringify(navLink)
        });
      }
    }
    
    return result;
  }

  ToEpubSummary(
    serverData: HTMLCollectionOf<Element>,
    summary_type: string
  ): any {
    var result: any[] = [];

    let removeExtraSpace = (s: string | null) =>
      s
        ?.trim()
        .split(/ +/)
        .join(" ")
        .replace(/(\r\n|\n|\r)/gm, "");

    const values = Array.from(serverData).map((navPoint) => {
      const [content] = navPoint.getElementsByTagName('content');
      const navLink = content.getAttribute('src');
      result.push({
        type: "pub",
        uid: navPoint.id.toString(),
        title: removeExtraSpace(navPoint.textContent),
        navLink,
      });
    });

    return result;
  }

  ToContentComplete(serverData: any): RemoteContentDetail {
    var content = this.ToContent(serverData, false);
    var result: RemoteContentDetail = {
      ...content,
      author: serverData.properties.find((p: any) => p.name === "Autor")?.value ?? "-" ,
      description: serverData.description,
      readingTime:
        serverData.properties.find((p: any) => p.name == "Tempo de leitura")
          ?.value ?? "Tempo não estimado",
      evaluation: "0",
      references: serverData.references.map((p: any) => {
        return this.ToContentReference(p);
      }),
    };
    return result;
  }

  ToContentReference(serverData: any): RemoteContentReference 
  {
    var reference: RemoteContentReference = {
      uid: serverData.uid,
      mimeType: serverData.mime_type,
      products: [],
      url: Sdk.Api.dynamic.bridgeUrl(
        `cms/v1.1/managed/content/reference/uid/${serverData.uid}/content`,
        null
      ),
      downloadProgress: serverData.download_progress,
    };

    if (serverData.mime_type.indexOf("epub") != -1)
    {
      reference.format = ContentType.EPUB;
    }
    else if (serverData.mime_type.indexOf("pdf") != -1){
      reference.format = ContentType.PDF;
    }
    else {
      reference.format = ContentType.AUDIOBOOK;
    }

    return reference;
  }

  ToCategory(entity: any): Category {
    var defaultColor = "#084c8a";

    if (entity.data.Cor && entity.data.Cor.length > 0) {
      defaultColor = entity.data.Cor;
    }

    var result: Category = {
      uid: entity.uid,
      label: entity.name,
      backgroundColor: defaultColor,
      childs: [],
    };

    if (entity.childs) {
      for (const child of entity.childs) {
        const childCategory = this.ToCategory(child);
        result.childs?.push(childCategory);
      }
    }

    return result;
  }

  async LoadSchemas(): Promise<RemoteSchema[]> {
    var url = `auth/v1.1/entity/schema/available?type=category`;
    var response: RemoteSchema[] = await Sdk.Api.dynamic.bridge(
      url,
      null,
      "GET"
    );

    return response;
  }

  async LoadEntities(schema: any): Promise<any[]> {
    var url = `auth/v1.1/entity/schema/uid/${schema.uid}/items/tree`;
    var response: any[] = await Sdk.Api.dynamic.bridge(url, null, "GET");
    return response;
  }

  async GetUserEvaluation(contentId: string): Promise<any> {
    const url = `review/managedContent/uid//score/user`
    const result = Sdk.Api.dynamic.bridge(url, null, 'GET')
    return result
}

}
